import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function StickerFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedPack, setSelectedPack] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const categories = [
    { id: "all", name: "Todos" },
    { id: "emotions", name: "Emoções" },
    { id: "reactions", name: "Reações" },
    { id: "animals", name: "Animais" },
    { id: "love", name: "Amor" },
    { id: "memes", name: "Memes" },
    { id: "anime", name: "Anime" },
    { id: "custom", name: "Personalizados" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/sticker?page=${pageNum}&limit=20`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stickers:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  const handleEditPost = (post) => {
    setSelectedPack(null);
    setEditingPost(post);
  };

  const handlePostUpdated = (updatedPost) => {
    setPosts((prev) => prev.map((p) => (p._id === updatedPost._id ? updatedPost : p)));
    setEditingPost(null);
  };

  const handlePostDeleted = (postId) => {
    setPosts((prev) => prev.filter((p) => p._id !== postId));
    setSelectedPack(null);
  };

  if (loading && posts.length === 0) {
    return <div className="sticker_feed_loading"><div className="sticker_loader"></div><span>Carregando stickers...</span></div>;
  }

  return (
    <div className="sticker_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="sticker_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM17 11h-4v4h-2v-4H7V9h4V5h2v4h4v2z"/>
          </svg>
          <h3>Nenhum sticker encontrado</h3>
          <p>Seja o primeiro a criar um pacote!</p>
        </div>
      ) : (
        <div className="sticker_grid">
          {posts.map((post) => (
            <div key={post._id} className="sticker_pack" onClick={() => setSelectedPack(post)}>
              <div className="sticker_preview">
                {(post.stickerData?.stickers || post.images || []).slice(0, 4).map((sticker, i) => (
                  <img key={i} src={sticker.url || sticker} alt="" />
                ))}
              </div>
              <div className="sticker_pack_info">
                <h3>{post.stickerData?.packName || post.text || "Pacote de Stickers"}</h3>
                <div className="sticker_pack_meta">
                  <span>{post.stickerData?.stickers?.length || post.images?.length || 0} stickers</span>
                </div>
                <Link to={`/profile/${post.user.username}`} className="sticker_creator" onClick={(e) => e.stopPropagation()}>
                  <img src={post.user.picture} alt="" />
                  <span>{post.user.first_name}</span>
                </Link>
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="sticker_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais pacotes"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedPack && (
        <div className="sticker_modal_overlay" onClick={() => setSelectedPack(null)}>
          <div className="sticker_modal" onClick={(e) => e.stopPropagation()}>
            <button className="sticker_modal_close" onClick={() => setSelectedPack(null)}>✕</button>
            <div className="sticker_modal_header">
              <h2>{selectedPack.stickerData?.packName || "Pacote de Stickers"}</h2>
              <Link to={`/profile/${selectedPack.user.username}`} className="sticker_modal_creator">
                <img src={selectedPack.user.picture} alt="" />
                <span>por {selectedPack.user.first_name}</span>
              </Link>
            </div>
            <div className="sticker_modal_grid">
              {(selectedPack.stickerData?.stickers || selectedPack.images || []).map((sticker, i) => (
                <div key={i} className="sticker_modal_item">
                  <img src={sticker.url || sticker} alt="" />
                </div>
              ))}
            </div>
            <div className="sticker_modal_footer">
              <button className="sticker_add_btn">Adicionar ao WhatsApp</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
